String.prototype.toFloat = function() {
    return parseFloat(this.replace(/[^0-9-.]/g, '')) || 0;
};

String.prototype.toMoney = Number.prototype.toMoney;
